// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__9fHWL","tabs":"styles_tabs__zLpLP","singleTab":"styles_singleTab__wic7M","activeSingleTab":"styles_activeSingleTab__HdQpK"};